module.exports = __webpack_public_path__ + "img/ic_search_hanging.ebec8654.svg";